import { render, staticRenderFns } from "./MerchantsRoleSelector.vue?vue&type=template&id=629b4eeb&"
import script from "./MerchantsRoleSelector.vue?vue&type=script&lang=js&"
export * from "./MerchantsRoleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports